import React from "react";

/** One activity/time cell of the occupancy board. `slot` comes from buildBoardColumn(). */
const SlotCell = ({ slot }) => {
  if (!slot) {
    return (
      <td>
        <span className="pill muted">–</span>
      </td>
    );
  }

  const { current_capacity: freeSpots = 0, max_capacity: maxCapacity = 0 } = slot.capacityInfo;
  const reservedCount = maxCapacity - freeSpots;
  const scannedCount = slot.teams.filter((team) => team.scanned).length;
  // A fully booked slot with no scans yet is displayed as fully checked in (kept from the original board).
  const displayedScanned = reservedCount > 0 && scannedCount === 0 && freeSpots === 0 ? reservedCount : scannedCount;

  return (
    <td>
      <div className="cell-head">
        <span className="cell-time">{slot.time}</span>
        <div className="meta">
          <span className={`pill ${freeSpots > 0 ? "open" : "full"}`}>
            {freeSpots}/{maxCapacity}
          </span>
          {reservedCount > 0 && (
            <span className="pill scanned" title="Naskenováno / rezervováno">
              {displayedScanned}/{reservedCount}
            </span>
          )}
        </div>
      </div>
      {slot.teams.length > 0 && (
        <div className="teams">
          {slot.teams.map((team, index) => (
            <span key={`${team.team_name}-${index}`} className={`team ${team.scanned ? "scanned" : "pending"}`}>
              {team.team_name} ({team.team_number})
            </span>
          ))}
        </div>
      )}
    </td>
  );
};

export default SlotCell;
